import { useTranslation } from 'react-i18next'

import { Box } from '@hivewatch/dark'

export const MediaError = () => {
  const { t } = useTranslation()
  return (
    <Box
      alignItems='center'
      display='flex'
      fontSize='18px'
      fontWeight={500}
      h='324px'
      justifyContent='center'
      w='100%'
    >
      {t('incidents:media_error_loading_image')}
    </Box>
  )
}
